module.exports = __webpack_public_path__ + "media/recipes/146-3193f7da.png";